(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-hero-section]');
    sections.forEach(function (section) {
      var video = section.querySelector('video.hero-section__video');
      if (!video) return;

      var play = function () {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {});
        }
      };

      if (document.readyState === 'complete') {
        play();
      } else {
        window.addEventListener('load', play, { once: true });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play();
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.1 });
        observer.observe(video);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
